// Rows for showing a customer's custom_fields (what their signup form collected
// beyond the standard columns). Values are keyed by the store's field
// definitions' `field`, which is what app-public-form submits under.
//
// Defined fields come first, in the order the merchant created them and under
// their labels. Anything else the customer carries — a field since deleted from
// the store, an imported key — follows under its raw key, so no collected
// value is silently hidden.
export function customFieldRows(values, definitions) {
  if (!values || typeof values !== "object") return [];

  const rows = [];
  const seen = new Set();

  for (const definition of definitions ?? []) {
    if (!(definition.field in values)) continue;
    rows.push({
      key: definition.field,
      label: definition.label || definition.field,
      value: values[definition.field],
    });
    seen.add(definition.field);
  }

  for (const key of Object.keys(values).sort()) {
    if (seen.has(key)) continue;
    rows.push({ key, label: key, value: values[key] });
  }

  return rows;
}

// Checkbox fields arrive as an array of the ticked options; imports can leave
// booleans. `t` supplies the yes/no wording.
export function formatCustomFieldValue(value, t) {
  if (value === null || value === undefined || value === "") return "-";
  if (Array.isArray(value)) return value.length ? value.join(", ") : "-";
  if (typeof value === "boolean") {
    return t(value ? "customers.show.yes" : "customers.show.no");
  }
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
